import * as React from "react";

export const UpdateContext = React.createContext(null);
